export default __webpack_public_path__ + "static/media/brand-name.9df2d31f.svg";